import { observer } from 'mobx-react-lite';
import useSetPageTitle from 'utilities/useSetPageTitle';
import './LearningHub.scss';
import { useTranslation } from 'react-i18next';
import { ModuleLibrary } from './ModuleLibrary/ModuleLibrary';

export const LearningHub = observer(() => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('LearningHub', { ns: 'learningHub' }),
    subtitle: t('Description', { ns: 'learningHub' }),
  });

  return <ModuleLibrary />;
});
